import React, { Component } from "react";
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import { t } from './i18n';
class PopupManager extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }
    constructor(props) {
        super(props);
        // [2026-11-04] เดิมเก็บ "true" ถาวร (ไม่โชว์อีกเลย) -> เก็บวันที่ ซ่อนแค่วันนั้น
        const hideToday = localStorage.getItem("hidePopupToday") === new Date().toDateString();

        this.state = {
            currentPopupIndex: 0,
            popups: [],
            hideToday,
        };
    }
    async componentDidMount() {
        if (this.state.hideToday) return; // [2026-11-04] ซ่อนวันนี้แล้ว ไม่ต้องโหลด
        await this.getpopup();
    }
    getCache = (key, ttl) => {
        const cachedData = JSON.parse(localStorage.getItem(key));
        if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
            return cachedData.data;
        }
        return null;
    };
    
    setCache = (key, data) => {
        localStorage.setItem(key, JSON.stringify({
            timestamp: Date.now(),
            data: data,
        }));
    };
    getpopup = () => {
        const cacheKey = "popup_list"; // Key สำหรับ Cache
        const cachedData = this.getCache(cacheKey, 15 * 60 * 1000); // [2026-11-04] เดิมไม่ส่ง ttl -> ไม่เคยใช้ cache
        
        if (cachedData) {
          console.log("Using cached data for popups:", cachedData);
          this.setState({
            popups: cachedData,
          });
        } else {
          // หากไม่มีข้อมูลใน Cache หรือ Cache หมดอายุ
          instance
            .post("/api/v1/popuplist", {
              System: Systems,
              Cat_ID: 0,
              page: 1,
              type: 1,
            })
            .then(async (res) => {
              console.log("PPPOPPPIPPPPUP", res.data);
              if (res.data.status === 200) {
                const filteredPopups = res.data.message.tblPopupMenu1.filter(
                  (popup) => popup.status === 1
                );
        
                // เก็บข้อมูลใน Cache เป็นเวลา 15 นาที
                this.setCache(cacheKey, filteredPopups, 15);
        
                this.setState({
                  popups: filteredPopups,
                });
              }
            })
            .catch(async (err) => {
              console.error("Error fetching popuplist:", err);
            });
        }
        

    }
    handleNext = () => {
        this.setState((prevState) => ({
            currentPopupIndex: Math.min(
                prevState.currentPopupIndex + 1,
                prevState.popups.length - 1
            ),
        }));
    };
    handleBack = () => {
        this.setState((prevState) => ({
            currentPopupIndex: Math.max(prevState.currentPopupIndex - 1, 0),
        }));
    };

    handleClose = () => {
        this.setState({ currentPopupIndex: null });
    };

    handleHideToday = () => {
        // Save the "Don't Show Again Today" state in localStorage
        localStorage.setItem("hidePopupToday", new Date().toDateString());
        this.setState({ hideToday: true, currentPopupIndex: null });
    };

    render() {
        const { currentPopupIndex, popups, hideToday } = this.state;

        if (hideToday || currentPopupIndex === null) {
            return null;
        }
        const popup = popups[currentPopupIndex];
        if (popups.length > 0) {
            const btnStyle = {
                background: "#ff6600",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                padding: "8px 22px",
                cursor: "pointer",
                fontSize: 15,
                fontWeight: "bold",
                margin: "0 4px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
            };
            return (
                <div
                    key={popup.id}
                    style={{
                        position: "fixed",
                        inset: 0,
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(0,0,0,0.7)",
                    }}
                    onClick={this.handleClose}
                >
                    <div
                        style={{ position: "relative", maxWidth: "90vw", maxHeight: "90vh" }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <img
                            alt={t(this.lang, 'announcement_label')}
                            src={popup.img}
                            style={{
                                display: "block",
                                maxWidth: "90vw",
                                maxHeight: "80vh",
                                width: "auto",
                                height: "auto",
                                borderRadius: 0,
                            }}
                        />
                        <div style={{ display: "flex", justifyContent: "center", marginTop: 10, gap: 8 }}>
                            {currentPopupIndex > 0 && (
                                <button style={btnStyle} onClick={this.handleBack}>Back</button>
                            )}
                            {currentPopupIndex < popups.length - 1 ? (
                                <button style={btnStyle} onClick={this.handleNext}>Next</button>
                            ) : (
                                <>
                                    <button style={btnStyle} onClick={this.handleHideToday}>
                                        {t(this.lang, 'hide_today')}
                                    </button>
                                    <button style={btnStyle} onClick={this.handleClose}>Close</button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default PopupManager;
